module.exports = __webpack_public_path__ + "img/imagem-fundo3.dd7cbc53.png";